const POSITIONS = [
  { name: 'SB', order: 0 },
  { name: 'BB', order: 1 },
  { name: 'UTG', order: 2 },
  { name: 'UTG+1', order: 3 },
  { name: 'MP', order: 4 },
  { name: 'HJ', order: 5 },
  { name: 'LJ', order: 6 },
  { name: 'CO', order: 7 },
  { name: 'BTN', order: 8 }
];

const DEFAULT_STACK = 200;
const BLINDS = { small: 0.5, big: 1 };

export const getPositions = () => [...POSITIONS];

export const createInitialGameState = () => {
  const stacks = POSITIONS.reduce((acc, pos) => {
    acc[pos.name] = DEFAULT_STACK;
    return acc;
  }, {});

  return {
    tableSize: POSITIONS.length,
    stacks,
    actions: {
      preflop: [
        { position: 'SB', action: 'posts', amount: BLINDS.small, isBlind: true, timestamp: Date.now() },
        { position: 'BB', action: 'posts', amount: BLINDS.big, isBlind: true, timestamp: Date.now() + 1 }
      ],
      flop: [],
      turn: [],
      river: [],
      showdown: []
    },
    playerCards: {},
    board: { flop: [], turn: [], river: [] },
    blinds: { ...BLINDS }
  };
};
